import React from "react";

import { cn } from "@/utils/cn";

interface OutlineBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

/** Wraps children in a container with an outline. */
const OutlineBox: React.FC<OutlineBoxProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <div className={cn("rounded-2xl border p-4", className)} {...rest}>
      {children}
    </div>
  );
};

export default OutlineBox;
